import React from "react";
import { Typography } from "@material-ui/core";
import {
  AddIcon,
  CheckIcon,
  ExportIcon,
  InvoiceIcon,
  RemoveIcon,
  XIcon,
} from "../../../components/common/iconography";

export const InvoiceSetupCreateHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>Invoice Setup</strong>
    </Typography>
    <Typography variant="subtitle1">
      There are two ways to start / create a new Invoice. Firstly, by using the{" "}
      <br />
      <AddIcon className={classes.icon} />
      <strong> INVOICE </strong> button in the RELEASED tab of both Inbound and
      Outbound shipments list. This will automatically pre-populate the invoice
      with required data for that shipment. Secondly, you can start a "blank"
      incoice by using the <br />
      <AddIcon className={classes.icon} />
      <strong> CREATE </strong> button at the top of Invoices List.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Account: </strong>
          Account must be selected first to enable other fields.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Point Of Contact: </strong>
          Billing point of contact, if any. Will be displayed as Attn. in Bill
          To address.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>PO Number: </strong>
          Automatically populated from Inbound/Outbound Shipment. Enter custom
          PO number for ad-hoc charges.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Service Date: </strong>
          Automatically set to Inbount / Outbound Release date if available.
          Otherwise, select date of service.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Due Date: </strong>
          Automatically set to Pyment Terms specified in Account Invoice Setup.
          Change if needed to any future date.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Invoice Notes: </strong>
          Notes applicable to the entire invoice - not specific to individual
          charges.
        </Typography>
      </li>
    </ul>
  </>
);

export const InvoiceSetupEditHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>Invoice Setup</strong>
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Account: </strong>
          Account must be selected first to enable other fields.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Point Of Contact: </strong>
          Billing point of contact, if any. Will be displayed as Attn. in Bill
          To address.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>PO Number: </strong>
          Automatically populated from Inbound/Outbound Shipment. Enter custom
          PO number for ad-hoc charges.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Service Date: </strong>
          Automatically set to Inbount / Outbound Release date if available.
          Otherwise, select date of service.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Due Date: </strong>
          Automatically set to Pyment Terms specified in Account Invoice Setup.
          Change if needed to any future date.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Invoice Notes: </strong>
          Notes applicable to the entire invoice - not specific to individual
          charges.
        </Typography>
      </li>
      <li>
        <Typography>
          <CheckIcon className={classes.icon} />
          <strong> COMPLETE: </strong>
          Mark invoice as paid/completed, reset balance to zero, and move to
          "COMPLETED" tab. Visible if invoice is pending.
        </Typography>
      </li>
      <li>
        <Typography>
          <XIcon className={classes.icon} />
          <strong> REOPEN: </strong>
          Mark invoice as not paid/completed, and move to "DRAFT" tab. Visible
          if invoice is pending or completed.
        </Typography>
      </li>
      <li>
        <Typography>
          <ExportIcon className={classes.icon} />
          <strong> EXPORT: </strong>
          Download and Excel export of current invoice. To learn how to impoirt
          into QuickBooks, please visit
          <a
            href="https://quickbooks.intuit.com/learn-support/en-uk/do-more-with-quickbooks/import-your-invoices-into-quickbooks/01/192319"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Invoice Import - QuickBooks Help
          </a>
          . You can also do a bulk export from Invoices List by selecting
          multiple invoice rows. To learn more about bulk import into
          QuickBooks, please visit
          <a
            href="https://quickbooks.intuit.com/learn-support/en-uk/manage-invoices/import-multiple-invoices-at-once/00/338726"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Bulk Invoice Import - QuickBooks Help
          </a>
          .
        </Typography>
      </li>
      <li>
        <Typography>
          <InvoiceIcon className={classes.icon} />
          <strong> VIEW: </strong>
          Show printable invoice. From the new view, you can print, save as PDF
          or email the invoice to the customer.
        </Typography>
      </li>
    </ul>
  </>
);

export const ChargesCreateHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>Charges</strong>
    </Typography>
    <Typography variant="subtitle1">
      Automatically populated if Invoice created from Inbound/Outbound Shipments
      List.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Service: </strong>
          Select Services / goods / consumables provided.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Service Note: </strong>
          Notes specific to this Service item.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Quantity / Units: </strong>
          Units and Quanity of Units handled for the Service. For "Accessorial
          Charges" use 1 PIECE or 1 UNIT.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Unit Price: </strong>
          Price per 1 Unit of measure.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Service Charge: </strong>
          TotalQuantity * Unit Price.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Tax Rate & Tax: </strong>
          Select a pre-configured Tax Rate - setup in My Yard config. Rate is
          automatically applied when configured for a given service.
        </Typography>
      </li>
      <li>
        <Typography>
          <AddIcon className={classes.icon} />
          <strong> ADD: </strong>
          Add new Service Line Item to the tally.
        </Typography>
      </li>
      <li>
        <Typography>
          <RemoveIcon className={classes.icon} />
          <strong> REMOVE: </strong>
          Remove selected Service Line Item.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Subtotal: </strong>
          Sum of all Service Charges.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Taxes: </strong>
          Calculated from Tax Rate configured during My Yard and Account
          Services setup.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Total Charges: </strong>
          Subtotal + Taxes
        </Typography>
      </li>
    </ul>
  </>
);

export const ChargesEditHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>Charges</strong>
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Service: </strong>
          Select Services / goods / consumables provided.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Service Note: </strong>
          Notes specific to this Service item.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Quantity / Units: </strong>
          Units and Quanity of Units handled for the Service. For "Accessorial
          Charges" use 1 PIECE or 1 UNIT.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Unit Price: </strong>
          Price per 1 Unit of measure.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Service Charge: </strong>
          TotalQuantity * Unit Price.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Tax Rate & Tax: </strong>
          Select a pre-configured Tax Rate - setup in My Yard config. Rate is
          automatically applied when configured for a given service.
        </Typography>
      </li>
      <li>
        <Typography>
          <AddIcon className={classes.icon} />
          <strong> ADD: </strong>
          Add new Service Line Item to the tally.
        </Typography>
      </li>
      <li>
        <Typography>
          <RemoveIcon className={classes.icon} />
          <strong> REMOVE: </strong>
          Remove selected Service Line Item.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Subtotal: </strong>
          Sum of all Service Charges.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Taxes: </strong>
          Calculated from Tax Rate configured during My Yard and Account
          Services setup.
        </Typography>
      </li>
      <li>
        <Typography gutterBottom>
          <strong>Total Charges: </strong>
          Subtotal + Taxes
        </Typography>
      </li>
    </ul>
  </>
);

export const HistoryEditHelp = ({ classes }) => (
  <>
    <Typography variant="subtitle1">
      <strong>History Log</strong>
    </Typography>
    <Typography variant="subtitle1">
      The History Tab provides an automated, chronological Audit Trail of key
      events and record changes.
    </Typography>
  </>
);
